import type { CSSProperties, ReactNode } from 'react';
import type { SizeScale } from '@pv-frontend/design-tokens';
import { vars } from '../../theme/contract.css';

export type Align =
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-around'
    | 'space-between'
    | 'space-evenly';

export type InlineAlign = 'flex-start' | 'center' | 'flex-end' | 'baseline' | 'stretch';

export type BlockStackProps = {
    children?: ReactNode;
    id?: string;
    /** Main-axis (vertical) distribution → `justify-content`. */
    align?: Align;
    /** Cross-axis (horizontal) alignment → `align-items`. */
    inlineAlign?: InlineAlign;
    gap?: SizeScale;
    reverseOrder?: boolean;
    flex?: number;
};

/** Vertical flex stack — mirrors the RN `BlockStack`. */
export function BlockStack({ children, id, align, inlineAlign, gap, reverseOrder, flex }: BlockStackProps) {
    const style: CSSProperties = {
        display: 'flex',
        flexDirection: reverseOrder ? 'column-reverse' : 'column',
        justifyContent: align,
        alignItems: inlineAlign,
        gap: gap ? vars.space[gap] : undefined,
        flex,
    };
    return (
        <div id={id} style={style}>
            {children}
        </div>
    );
}
